import type { i18n } from 'i18next'

const LANG_COUNTRY_CODE_BEGIN = 2

class LanguageUtils {
  static formatLanguage(lang: string) {
    return (
      lang.slice(0, LANG_COUNTRY_CODE_BEGIN).toLowerCase() + lang.slice(LANG_COUNTRY_CODE_BEGIN)
    ).replace('_', '-')
  }

  static changeLanguage(lang: string, i18n: i18n) {
    i18n.changeLanguage(this.formatLanguage(lang))
  }
}

export default LanguageUtils
